import React, { Component } from "react";

import { Input, message } from 'antd';
import WidgetAjax from "../../widget/WidgetAjax";
import Config from "../../config/Config";
import './../../css/frame.css';
import './../../css/project.css';
import './index.scss';

class Query extends Component {

    constructor(props) 
    {
        super(props);

        this.state = {
            ENTNAME: '',
            UNISCID: ''
        }
    }
    
    onChange(value) {
        console.log(value);
    };
    goPage(){
        window.history.back(-1)
    };
    queryCheckEntType(){
        
        if(!this.state.UNISCID){
            message.warning('请输入统一社会信用代码');
            return
        }
        WidgetAjax.ajax({
            url : Config.getBasePath()+'/businessSystem/checkEntType', 
            params : {
                ENTNAME: this.state.ENTNAME,
                UNISCID: this.state.UNISCID
            }, 
            callback : (data)=>{
                if(data&&data.status === 0){
                    localStorage.setItem("ENTTYPE",data.result.ENTTYPE)
                    window.history.back(-1)
                    
                }
            }
        },this);
    }
    render()
    {
        let { ENTNAME, UNISCID } = this.state
        return (
            <div data-component="query">
                <div className="sg-login">
                    <div className="sg-login-top sd-start">
                        <div onClick={this.goPage} className="sd-start">
                            <img className='sg-title-img1' alt='#' src={require('../../img/business/upPage.png')}/>
                            <span className="sg-top-font">返回</span>
                        </div>
                    </div>
                    <div className="sg-login-center">
                        <div className="sg-center-top sd-start">
                            <span className="sg-center-font">查询</span>
                        </div>
                        <div className="sg-center-middle sd-columnCenter">
                            <div className="sg-middle-list sd-middle">
                                <div className="sg-list-left sd-middle">个体工商户名称：</div>
                                <Input placeholder="请输入个体工商户名称" bordered={false} value={ENTNAME} onChange={(e)=>this.setState({ENTNAME:e.target.value})}/>
                            </div>
                            <div className="sg-middle-list sd-middle">
                                <div className="sg-list-left sd-middle"><span style={{color:'#ff0000',marginRight:'4px'}}>*</span>统一社会信用代码:</div>
                                <Input placeholder="请输入统一社会信用代码" bordered={false} value={UNISCID} onChange={(e)=>this.setState({UNISCID:e.target.value})}/>
                            </div>
                            <div className="sg-middle-bottom sd-middle">
                                <div className="sg-bottom-btn sd-middle" onClick={()=>{this.queryCheckEntType()}}>查询</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Query
